import { EventEmitter, Directive, Input, Output, HostListener, TemplateRef, ViewContainerRef, HostBinding, ChangeDetectorRef, NgModule } from '@angular/core';
import { ScreenSizeService, config } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ConfirmModalTermsComponent } from '@fgb/portal-component-library/src/lib/shared/confirm-modal-terms';
import { TranslateService } from '@ngx-translate/core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc2 from '@fgb/core';
import * as ɵngcc3 from '@ngx-translate/core';
class ConfirmModalTermsDirective {
    constructor(modalService) {
        this.modalService = modalService;
        this.valid = true;
        this.confirm = new EventEmitter();
        this.destroy$ = new Subject();
    }
    onClick() {
        if (this.cancelModal)
            return;
        this.modal = this.modalService.open(ConfirmModalTermsComponent, {
            size: !!this.confirmImage ? 'lg' : undefined,
            centered: true,
        });
        this.modalComponent = this.modal.componentInstance;
        this.modalComponent.modalContent = this.confirmContent;
        this.modalComponent.imageRef = this.confirmImage;
        this.modalComponent.termsAndCondtions = this.termsAndCondtions;
        this.modalComponent.close.pipe(takeUntil(this.destroy$)).subscribe((x) => {
            this.modal.close(x);
        });
        this.modalComponent.confirm.pipe(takeUntil(this.destroy$)).subscribe((x) => {
            this.confirm.emit(x);
            this.modal.close(x);
        });
    }
    ngOnChanges() {
        if (!this.valid) {
            this.modal.close();
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
ConfirmModalTermsDirective.ɵfac = function ConfirmModalTermsDirective_Factory(t) { return new (t || ConfirmModalTermsDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgbModal)); };
ConfirmModalTermsDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ConfirmModalTermsDirective, selectors: [["", "confirmModalTerms", ""]], hostBindings: function ConfirmModalTermsDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function ConfirmModalTermsDirective_click_HostBindingHandler() { return ctx.onClick(); });
    } }, inputs: { valid: "valid", termsAndCondtions: "termsAndCondtions", cancelModal: "cancelModal", confirmImage: "confirmImage", confirmContent: "confirmContent" }, outputs: { confirm: "confirm" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
ConfirmModalTermsDirective.ctorParameters = () => [
    { type: NgbModal }
];
ConfirmModalTermsDirective.propDecorators = {
    termsAndCondtions: [{ type: Input }],
    cancelModal: [{ type: Input }],
    confirmImage: [{ type: Input }],
    confirmContent: [{ type: Input }],
    valid: [{ type: Input }],
    confirm: [{ type: Output }],
    onClick: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConfirmModalTermsDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: '[confirmModalTerms]'
            }]
    }], function () { return [{ type: ɵngcc1.NgbModal }]; }, { valid: [{
            type: Input
        }], confirm: [{
            type: Output
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }], termsAndCondtions: [{
            type: Input
        }], cancelModal: [{
            type: Input
        }], confirmImage: [{
            type: Input
        }], confirmContent: [{
            type: Input
        }] }); })();

var ScreenType;
(function (ScreenType) {
    ScreenType[ScreenType["Mobile"] = 0] = "Mobile";
    ScreenType[ScreenType["Desktop"] = 1] = "Desktop";
})(ScreenType || (ScreenType = {}));
/** Creates the view only for the selected window size.
 * Will only create the view once even if window size changes, afterwards it is simply detached/reinserted.
 * Usage: *ifScreenSize="ScreenType.Mobile" or *ifScreenSize="ScreenType.Desktop"
 * */
class IfScreenSizeDirective {
    constructor(templateRef, viewContainer, screenSizeService) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.screenSizeService = screenSizeService;
    }
    set ifScreenSize(media) {
        this.resizeSubscription = this.screenSizeService
            .selectScreenWidth()
            .pipe(tap((width) => this.resizeCheck(width, media)))
            .subscribe();
    }
    /** Creates Embedded View */
    createView() {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.embeddedView = this.viewContainer.get(0);
    }
    /** On selected media, creates or display existing view.
     * Otherwise, detaches the view without destroying it.
     */
    resizeCheck(width, media) {
        if (this.screenMatchesSelector(width, media)) {
            if (this.embeddedView) {
                this.viewContainer.insert(this.embeddedView);
            }
            else {
                this.createView();
            }
        }
        else {
            this.viewContainer.detach();
        }
    }
    /** Checks if the screen width matches the selected media option */
    screenMatchesSelector(width, media) {
        const mobileBreakPoint = this.getDesktopBreakpointValue();
        const mobileCheck = media == ScreenType.Mobile && width < mobileBreakPoint;
        const desktopCheck = media == ScreenType.Desktop && width >= mobileBreakPoint;
        return mobileCheck || desktopCheck;
    }
    /** Get the desktop breakpoint from bootstrap variables defined as $grid-breakpoints */
    getDesktopBreakpointValue() {
        const bodyStyles = window.getComputedStyle(document.body);
        const mobileBreakpointSASSValue = bodyStyles.getPropertyValue('--breakpoint-lg');
        const mobileBreakpointNumber = +mobileBreakpointSASSValue.replace('px', '');
        return mobileBreakpointNumber;
    }
    ngOnDestroy() {
        if (this.resizeSubscription) {
            this.resizeSubscription.unsubscribe();
        }
    }
}
IfScreenSizeDirective.ɵfac = function IfScreenSizeDirective_Factory(t) { return new (t || IfScreenSizeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ScreenSizeService)); };
IfScreenSizeDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: IfScreenSizeDirective, selectors: [["", "ifScreenSize", ""]], hostBindings: function IfScreenSizeDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("beforeunload", function IfScreenSizeDirective_beforeunload_HostBindingHandler() { return ctx.ngOnDestroy(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { ifScreenSize: "ifScreenSize" } });
IfScreenSizeDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: ScreenSizeService }
];
IfScreenSizeDirective.propDecorators = {
    ifScreenSize: [{ type: Input }],
    ngOnDestroy: [{ type: HostListener, args: ['window:beforeunload',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IfScreenSizeDirective, [{
        type: Directive,
        args: [{
                selector: '[ifScreenSize]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc2.ScreenSizeService }]; }, { ifScreenSize: [{
            type: Input
        }], ngOnDestroy: [{
            type: HostListener,
            args: ['window:beforeunload']
        }] }); })();

/**
 * Enables a default image source to be specified that will be shown upon image retrieval error (i.e. HTTP 404).
 * Usage:
 *  <img src="https://www.normal-image-address.com/image.jpg" useDefault="true"></img>
 */
class ImgDefaultDirective {
    constructor() {
        this.imageLoaded = false;
        this.imageError = false;
    }
    ngOnInit() {
        if (!this.loyaltyType) {
            this.DefaultImgSrc = `${config.contentUrl}/images/noimage.png`;
        }
        else {
            switch (this.loyaltyType) {
                case 'marketplace': {
                    this.DefaultImgSrc = 'assets/images/placeholders/marketplace-item.png';
                    break;
                }
                case 'auction': {
                    this.DefaultImgSrc = 'assets/images/placeholders/auction-item.png';
                    break;
                }
                case 'lotto': {
                    this.DefaultImgSrc = 'assets/images/placeholders/lotto-item.png';
                    break;
                }
                case 'wallet': {
                    this.DefaultImgSrc = 'assets/images/placeholders/marketplace-item.png';
                    break;
                }
                case 'badge': {
                    this.DefaultImgSrc = 'assets/images/placeholders/badge-item.png';
                    break;
                }
                default: {
                    this.DefaultImgSrc = 'assets/images/placeholders/marketplace-item.png';
                    break;
                }
            }
        }
    }
    /**
     * Called on error. Sets the default image source if required and the class to 'image-error'.
     */
    updateUrl() {
        if (this.useDefault) {
            this.src = this.DefaultImgSrc;
        }
        this.imageError = true;
    }
    /**
     * Called on success. Leaves the requested image source as-is and sets the class to 'image-loaded'.
     */
    load() {
        this.imageLoaded = true;
    }
}
ImgDefaultDirective.ɵfac = function ImgDefaultDirective_Factory(t) { return new (t || ImgDefaultDirective)(); };
ImgDefaultDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ImgDefaultDirective, selectors: [["img", "useDefault", ""]], hostVars: 5, hostBindings: function ImgDefaultDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("error", function ImgDefaultDirective_error_HostBindingHandler() { return ctx.updateUrl(); })("load", function ImgDefaultDirective_load_HostBindingHandler() { return ctx.load(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("src", ctx.src, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵclassProp("image-loaded", ctx.imageLoaded)("image-error", ctx.imageError);
    } }, inputs: { src: "src", useDefault: "useDefault", loyaltyType: "loyaltyType" } });
ImgDefaultDirective.ctorParameters = () => [];
ImgDefaultDirective.propDecorators = {
    src: [{ type: HostBinding, args: ['attr.src',] }, { type: Input }],
    useDefault: [{ type: Input }],
    loyaltyType: [{ type: Input }],
    imageLoaded: [{ type: HostBinding, args: ['class.image-loaded',] }],
    imageError: [{ type: HostBinding, args: ['class.image-error',] }],
    updateUrl: [{ type: HostListener, args: ['error',] }],
    load: [{ type: HostListener, args: ['load',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ImgDefaultDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: 'img[useDefault]'
            }]
    }], function () { return []; }, { imageLoaded: [{
            type: HostBinding,
            args: ['class.image-loaded']
        }], imageError: [{
            type: HostBinding,
            args: ['class.image-error']
        }], 
    /**
     * Called on error. Sets the default image source if required and the class to 'image-error'.
     */
    updateUrl: [{
            type: HostListener,
            args: ['error']
        }], src: [{
            type: HostBinding,
            args: ['attr.src']
        }, {
            type: Input
        }], 
    /**
     * Called on success. Leaves the requested image source as-is and sets the class to 'image-loaded'.
     */
    load: [{
            type: HostListener,
            args: ['load']
        }], useDefault: [{
            type: Input
        }], loyaltyType: [{
            type: Input
        }] }); })();

class NgSubscribeContext {
    constructor() {
        this.ngSubscribe = null;
    }
}
class NgSubscribeDirective {
    constructor(viewContainer, cdr, templateRef) {
        this.viewContainer = viewContainer;
        this.cdr = cdr;
        this.templateRef = templateRef;
        this.context = new NgSubscribeContext();
    }
    set ngSubscribe(inputObservable) {
        if (this.observable !== inputObservable) {
            this.observable = inputObservable;
            this.subscription && this.subscription.unsubscribe();
            this.subscription = this.observable.subscribe((value) => {
                this.context.ngSubscribe = value;
                this.cdr.markForCheck();
            });
        }
    }
    ngOnInit() {
        this.viewContainer.createEmbeddedView(this.templateRef, this.context);
    }
    ngOnDestroy() {
        this.subscription && this.subscription.unsubscribe();
    }
}
NgSubscribeDirective.ɵfac = function NgSubscribeDirective_Factory(t) { return new (t || NgSubscribeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
NgSubscribeDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NgSubscribeDirective, selectors: [["", "ngSubscribe", ""]], inputs: { ngSubscribe: "ngSubscribe" } });
NgSubscribeDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: ChangeDetectorRef },
    { type: TemplateRef }
];
NgSubscribeDirective.propDecorators = {
    ngSubscribe: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgSubscribeDirective, [{
        type: Directive,
        args: [{
                selector: '[ngSubscribe]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.TemplateRef }]; }, { ngSubscribe: [{
            type: Input
        }] }); })();

/**
 * This directive is used to hide features
 * throughout the portal depending on the
 * given feature flag set within website content.
 *
 * Example of usage:
 * <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.member.card'"> ... </ng-container>
 */
class WebsiteContentFeatureFlagDirective {
    constructor(translate, templateRef, viewContainer) {
        this.translate = translate;
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this._isDestroyed$ = new Subject();
    }
    ngOnInit() {
        if (this.featureKey) {
            let isEnabled = false;
            this.translate
                .stream(this.featureKey)
                .pipe(takeUntil(this._isDestroyed$))
                .subscribe((data) => {
                if (data === 'true') {
                    isEnabled = JSON.parse(data);
                }
            });
            if (isEnabled) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            }
        }
    }
    ngOnDestroy() {
        this._isDestroyed$.next();
        this._isDestroyed$.complete();
    }
}
WebsiteContentFeatureFlagDirective.ɵfac = function WebsiteContentFeatureFlagDirective_Factory(t) { return new (t || WebsiteContentFeatureFlagDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.TranslateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
WebsiteContentFeatureFlagDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: WebsiteContentFeatureFlagDirective, selectors: [["", "fgbWebsiteContentFeatureFlag", ""]], hostBindings: function WebsiteContentFeatureFlagDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("beforeunload", function WebsiteContentFeatureFlagDirective_beforeunload_HostBindingHandler() { return ctx.ngOnDestroy(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { featureKey: ["fgbWebsiteContentFeatureFlag", "featureKey"] } });
WebsiteContentFeatureFlagDirective.ctorParameters = () => [
    { type: TranslateService },
    { type: TemplateRef },
    { type: ViewContainerRef }
];
WebsiteContentFeatureFlagDirective.propDecorators = {
    featureKey: [{ type: Input, args: ['fgbWebsiteContentFeatureFlag',] }],
    ngOnDestroy: [{ type: HostListener, args: ['window:beforeunload',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WebsiteContentFeatureFlagDirective, [{
        type: Directive,
        args: [{
                selector: '[fgbWebsiteContentFeatureFlag]'
            }]
    }], function () { return [{ type: ɵngcc3.TranslateService }, { type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }]; }, { ngOnDestroy: [{
            type: HostListener,
            args: ['window:beforeunload']
        }], featureKey: [{
            type: Input,
            args: ['fgbWebsiteContentFeatureFlag']
        }] }); })();

class DirectivesModule {
}
DirectivesModule.ɵfac = function DirectivesModule_Factory(t) { return new (t || DirectivesModule)(); };
DirectivesModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DirectivesModule });
DirectivesModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DirectivesModule, { declarations: [IfScreenSizeDirective, WebsiteContentFeatureFlagDirective, ImgDefaultDirective, ConfirmModalTermsDirective, NgSubscribeDirective], exports: [IfScreenSizeDirective, WebsiteContentFeatureFlagDirective, ImgDefaultDirective, ConfirmModalTermsDirective, NgSubscribeDirective] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DirectivesModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    IfScreenSizeDirective,
                    WebsiteContentFeatureFlagDirective,
                    ImgDefaultDirective,
                    ConfirmModalTermsDirective,
                    NgSubscribeDirective,
                ],
                exports: [
                    IfScreenSizeDirective,
                    WebsiteContentFeatureFlagDirective,
                    ImgDefaultDirective,
                    ConfirmModalTermsDirective,
                    NgSubscribeDirective,
                ],
                imports: []
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ConfirmModalTermsDirective, DirectivesModule, IfScreenSizeDirective, ImgDefaultDirective, NgSubscribeContext, NgSubscribeDirective, ScreenType, WebsiteContentFeatureFlagDirective };

//# sourceMappingURL=fgb-portal-component-library-src-lib-directives.js.map